import { FC, useMemo } from 'react'
import { TreeItem } from '@mui/x-tree-view'
import { Box, Typography } from '@mui/material'
import { useWorkListsById } from '../WorkListsService'
import { WorklistsListResponse } from '@fireflyhealth/api'

interface WorklistNameProps {
  worklist: WorklistsListResponse[number]
  selectWorklist: (worklistId: number) => void
  worklistId: number | undefined
}

export const WorklistName: FC<WorklistNameProps> = (props: WorklistNameProps) => {
  const { result: workListsById } = useWorkListsById()
  const workList = useMemo(
    () => (props.worklist ? workListsById[props.worklist.id] : undefined),
    [props.worklist, workListsById],
  )

  const isSelected = props.worklist.id === props.worklistId

  return (
    <TreeItem
      onClick={() => {
        props.selectWorklist(props.worklist.id)
      }}
      sx={[
        {
          mt: '8px',
          ml: '-16px',
          '& > .MuiTreeItem-content': { pl: '32px', pr: '16px', cursor: 'pointer' },
        },
        isSelected && { bgcolor: 'action.selected' },
      ]}
      itemId={props.worklist.id.toString()}
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', py: '4px', cursor: 'pointer' }}>
          <Typography variant="body1" sx={{ flexGrow: 1, cursor: 'pointer' }}>
            {props.worklist.name}
          </Typography>
          <Typography variant="caption" sx={{ width: '1em' }}>
            {workList?.item_count}
          </Typography>
        </Box>
      }
    ></TreeItem>
  )
}
